import React, { useRef } from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    makeStyles,
    Typography
} from '@material-ui/core';
// import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SignatureCanvas from 'react-signature-canvas';
import { useDialog } from 'src/contexts/DialogContext';

const useStyles = makeStyles(() => ({
    cardHeaderAction: {
        margin: 'auto',
        alignSelf: 'center'
    }
}));

export function SignatureCard({ title, fileName, alreadyExists, signatureData, onSignatureSave, onSignatureDelete }) {
    const signatureCanvasRef = useRef(null);
    const classes = useStyles();
    const outputFormat = 'image/jpeg';

    const { openDialog } = useDialog();

    const getSignature = () =>
        openDialog(({ closeDialog }) => (
            <>
                <DialogTitle>{title}</DialogTitle>
                <SignatureCanvas
                    ref={signatureCanvasRef}
                    penColor="black"
                    backgroundColor="white"
                    canvasProps={{ width: 600, height: 300, className: 'sigCanvas', id: 'Sign' }}
                />
                <Box display="flex" justifyContent="right" gridGap={6} mr={1} mb={1}>
                    <Button
                        onClick={() => {
                            const data = signatureCanvasRef.current.getTrimmedCanvas().toDataURL(outputFormat);
                            onSignatureSave({ data, outputFormat });
                            closeDialog();
                        }}
                    >
                        Save
                    </Button>
                    <Button onClick={() => signatureCanvasRef.current.clear()}>Clear</Button>
                    <Button onClick={closeDialog}>Cancel</Button>
                </Box>
            </>
        ));

    // const downloadSignature = () => {
    //     const link = document.createElement('a');
    //     link.href = signatureData;
    //     link.download = `${fileName}.${outputFormat.split('/')[1]}`;
    //     link.style.display = 'none';
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // };

    return (
        <Card>
            <CardHeader
                title={title}
                classes={{ action: classes.cardHeaderAction }}
                action={
                    <Grid container spacing={1} alignItems="center">
                        {/* <Grid item>
                            <IconButton size="small" onClick={downloadSignature} disabled={!signatureData}>
                                <CloudDownloadIcon />
                            </IconButton>
                        </Grid> */}
                        <Grid item>
                            <IconButton size="small" onClick={onSignatureDelete} disabled={!signatureData && !alreadyExists}>
                                <DeleteForeverIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                }
            />
            <Divider />
            <CardContent>
                {signatureData ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100%" unselectable="on">
                        <img
                            onDragStart={e => e.preventDefault()}
                            src={signatureData}
                            alt="Signature"
                            style={{
                                maxWidth: '100%',
                                maxHeight: '100%'
                            }}
                        />
                    </Box>
                ) : alreadyExists ? (
                    <Typography variant="body1" color="textSecondary">
                        Signature not displayable in offline mode. If you want to change it, please delete the existing
                        signature and add a new one.
                    </Typography>
                ) : (
                    <Button fullWidth variant="outlined" onClick={getSignature}>
                        ADD SIGNATURE
                    </Button>
                )}
            </CardContent>
        </Card>
    );
}
